export enum UiActionType {
  TOGGLE_WORKBOOKS_MENU = 'TOGGLE_WORKBOOKS_MENU',
  TOGGLE_GLOBAL_MENU = 'TOGGLE_GLOBAL_MENU',
  SET_GLOBAL_MENU_WIDTH = 'SET_GLOBAL_MENU_WIDTH',
  TOGGLE_ONBOARDING_NAVIGATION_MENU_OVERLAY = 'TOGGLE_ONBOARDING_NAVIGATION_MENU_OVERLAY',
  TOGGLE_SUBMENU = 'TOGGLE_SUBMENU',
  CLOSE_MENU = 'CLOSE_MENU',
  TOGGLE_WORKBOOK_PAGE_SELECTOR_MENU = 'WORKBOOK.TOGGLE_PAGE_SELECTOR_MENU'
}

export enum Menu {
  GLOBAL_MENU = 'globalMenuOpen',
  GLOBAL_MENU_TUTORIAL = 'menuOpen',
  WORKBOOKS_MENU = 'workbooksMenuOpen'
}

export type UiState = {
  globalMenuOpen: boolean;
  onboardingNavigationOverlayOpen: boolean;
  workbooksMenuOpen: boolean;
  globalMenuWidth: number;
  isDeviceCompatible: boolean;
  isLoadingContent: boolean;
  selectedSubmenu: string;
  pageSelectorMenuOpen: boolean;
  menuOpen: boolean;
};

export type UiAction =
  | { type: UiActionType.TOGGLE_GLOBAL_MENU }
  | { type: UiActionType.TOGGLE_WORKBOOKS_MENU }
  | { type: UiActionType.SET_GLOBAL_MENU_WIDTH; data: number }
  | { type: UiActionType.TOGGLE_ONBOARDING_NAVIGATION_MENU_OVERLAY }
  | { type: UiActionType.CLOSE_MENU; data: string }
  | { type: UiActionType.TOGGLE_SUBMENU; data: string }
  | { type: UiActionType.TOGGLE_WORKBOOK_PAGE_SELECTOR_MENU; data: string }
  | any;
